import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Filter } from 'typings/filters'
const initialState: Filter[] = []
const defaultFiltersSlice = createSlice({
  name: 'applied',
  initialState,
  reducers: {
    defaultFilters(state, action: PayloadAction<Filter[]>) {
      return action.payload
    },
    clearAllFilters(state) {
      return initialState
    },
  },
})

export const { defaultFilters, clearAllFilters } = defaultFiltersSlice.actions

export default defaultFiltersSlice.reducer
